import React from 'react';
import Routes from './RouterGroup/Routes';

const App = () => <Routes />;

export default App;
